import React from 'react';
import { Box, Grid, TableCell, TableRow, Typography } from "@mui/material"
import { useSelector } from "react-redux"
import { WorkItemType } from "../../api/projects-api"
import { AppRootState } from "../../app/store"
import { WorkItemIcon } from "./WorkItemIcon"
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { setLocation } from '../../app/cookies';

type WorkItemProps = {
  id: number
  projectName: string
  projectId: number
}

export type LocationStateType = {
  itemID: number
  projectId: number
  projectName: string
}

export const WorkItem = React.memo((props: WorkItemProps) => {
  const navigate = useNavigate()
  const workItemsForProject = useSelector<AppRootState, Array<WorkItemType>>((state) => state.workItems.workItemsState[props.projectName])
  let item = workItemsForProject.find(i => i.id === props.id)
  if (!item) {
    item = {} as WorkItemType
  }
  console.log('ITEM', item)
  const locationState: LocationStateType = {
    itemID: item.id,
    projectId: props.projectId,
    projectName: props.projectName
  }

  let stateColor: string = 'rgb(178, 178, 178)'
  if (item.fields?.['System.State'] === 'Active') {
    stateColor = '#00a0d1'
  } else if (item.fields?.['System.State'] === 'Resolved') {
      stateColor = 'rgb(255, 157, 0)'
    } else if (item.fields?.['System.State'] === 'Closed'){
      stateColor = 'rgb(51, 153, 51)'
  }

  return (
    <TableRow
      hover
      key={item.id}
     style={{cursor: 'pointer', backgroundColor: item.isUpdated ? 'lightgrey' : ''}}
     onClick={() => {
      setLocation(props.projectName, props.projectId, props.id)
      navigate(item ? `/itemID/${item.id}` : `/itemID/`, { state: locationState })
    }}
    >
      <TableCell>
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex'
          }}>
          <Typography
            className={item.isUpdated ? 'updatedTask' : ''}
            style={{fontWeight: item.isUpdated ? '600' : '400'}}
            // color="textPrimary"
            variant="body1">
            {'#'}
            {item.id}
          </Typography>
        </Box>
      </TableCell>
      <TableCell >
        <Grid container alignItems="baseline" spacing={2}>
          <Grid className='navlink' style={{display: 'flex', justifyContent: 'flex-start'}} item >
             <WorkItemIcon workType={item.fields?.["System.WorkItemType"]} />
            <Typography className={item.isUpdated ? 'updatedTask' : ''} style={{fontWeight: item.isUpdated ? '600' : '400', paddingLeft: '5px'}}>
              {item.fields?.["System.Title"]}
            </Typography>
          </Grid>
        </Grid>
      </TableCell>
      <TableCell style={{ textAlign: 'center' }}>
        <Typography>
          {item.fields?.["Microsoft.VSTS.Common.Priority"]}
        </Typography>
      </TableCell>
      <TableCell style={{ textAlign: 'left' }}>
         <Typography variant="body2" style={{ display: 'inline-flex', alignItems: 'center' }}>
        <div style={{
          border: ' 1px solid', marginRight: '10px', width: '11px', height: '11px', backgroundColor: stateColor, borderRadius: '50%',
          borderColor: stateColor
        }}></div>
        {item.fields?.["System.State"]}
      </Typography>
      </TableCell>
      <TableCell style={{ textAlign: 'center' }}>
        <Typography>
          {item.fields?.['System.IterationPath'] === undefined ? ''
            : item.fields?.['System.IterationPath'] === props.projectName
              ? '' : 'verified'}
        </Typography>
      </TableCell>
      <TableCell style={{ textAlign: 'center' }}>
        <Typography>
          {item.fields?.['System.CreatedDate'] === undefined ? '' : moment(item.fields?.['System.CreatedDate']).locale('de').format('DD.MM.YYYY')}
        </Typography>
      </TableCell>
      <TableCell style={{ textAlign: 'right' }}>
        <Typography  className={item.isUpdated ? 'updatedTask' : ''} style = {{fontWeight: item.isUpdated ? '600' : '400'}}>
          {item.fields?.['System.ChangedDate'] === undefined ? '' 
                                                             : item.isUpdated ?  moment(item.fields?.['System.ChangedDate']).locale('de').format('DD.MM.YYYY HH:mm')
                                                             : moment(item.fields?.['System.ChangedDate']).locale('de').format('DD.MM.YYYY')}
        </Typography>
      </TableCell>
    </TableRow>
  )
})
